import axios from 'axios';
import Csm from '../entity/csm.entity';

export default class CsmService {
  static readonly PATH_URL = '/api/v1/csms';

  public static getCsms(): Promise<Csm[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => Csm.ofList(response.data));
  }

  public static create(csm: Csm): Promise<Csm> {
    return axios
      .post(this.PATH_URL, csm)
      .then((response: any) => Csm.of(response.data));
  }
}
